
import { Component, Vue } from "vue-property-decorator";

import PrimaryMenu from "@/components/navigation/PrimaryMenu.vue";

@Component({ components: { PrimaryMenu } })
export default class TabBar extends Vue {}
